const SERVER_URL = "https://peopleapi.appnestit.com"
// const SERVER_URL = "http://127.0.0.1:7000"

export {
    SERVER_URL
}